<template>
  <div v-if="!trigger">
    <AppHeader></AppHeader>
    <router-view></router-view>
    <AppFooter></AppFooter>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>
import { ref } from 'vue'
import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  name: 'MainLayout',
  components: {
    AppHeader,
    AppFooter,
  },
  setup() {
    const trigger = ref(localStorage.getItem('chkPoint'))
    return {
      trigger,
    }
  },
}
</script>
